// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__wZNED","select-disabled":"Select_select-disabled__3o2qT","select-v2":"Select_select-v2__nEv1U"};